import React from "react";
import {
    Button, CheckBoxField,
    convertInputFormToObject,
    InputForm, inputStyles,
    SelectField,
    TextField,
    useInputForm
} from "../../../Components/Inputs";
import {clearInputFormFields, createIsActiveList} from "../../../Components/Inputs/inputUtility";
import {createListFromArray, createListFromArrayOfObjects} from "../../../Utilities/Types/listUtilities";
import {jobTitles, PatronRoleSubtypesMap, createSubtypeListFromPatronRole} from "../../../SiteConfig/jobTitles";
import {SearchableSingleSelectField} from "../../../Components/Inputs/SearchableSingleSelectField";
import {Allow, policyEvents} from "../../../Components/Authorize";
import {GridContainer, GridCell, gridConstants} from "../../../Components/Grid";
import {APPROVAL_STATUS_LIST} from "../approvalConstants";
import {isAdmin} from "../../../Utilities/LocalStorage/storageUtilities";

interface UserApprovalSearchFormViewProps {
    buttonSharedSettings: Record<string, unknown>;
    districts: Record<string, any>[];
    handleSetUserSearchCriteria: (criteria: Record<string, unknown>) => void;
    isLoading: boolean;
    organizations: string[];
    userSearchCriteria: Record<string, any>;
    user: Record<string, any>;
}

export const UserApprovalSearchFormView: React.FC<UserApprovalSearchFormViewProps> = ({
                                        buttonSharedSettings,
                                        districts,
                                        handleSetUserSearchCriteria,
                                        isLoading,
                                        organizations,
                                        userSearchCriteria,
                                        user
                                    }) => {

    const searchForm = useInputForm(userSearchCriteria);
    const organizationOptions = createListFromArray(organizations);


    const handleClearClick = () => {
        clearInputFormFields(searchForm);
        const updatedUserSearchCriteria = {...userSearchCriteria};
        updatedUserSearchCriteria.ClearUserSearch();
    };

    const handleSearchClick = () => {
        let criteria = convertInputFormToObject(searchForm);
        const updatedUserSearchCriteria = {...userSearchCriteria};
        updatedUserSearchCriteria.Search(criteria);
        handleSetUserSearchCriteria(updatedUserSearchCriteria);
    };

    const inputSharedSettings = {
        large_columns: gridConstants.column.THREE,
        medium_columns: gridConstants.column.SIX,
    };

    return <>
        <InputForm name={"userSearch"}>

            <TextField
                {...searchForm.fullName}
                {...inputSharedSettings}
                label={`Name`}
            />

            <TextField
                {...searchForm.email}
                {...inputSharedSettings}
            />

            <Allow policyEvent={policyEvents.ADVANCE_SEARCH}>
                <SelectField
                    {...searchForm.organization}
                    {...inputSharedSettings}
                    defaultOptionValue={""}
                    defaultOption={"All"}
                    includeDefaultOption
                    options={organizationOptions}
                />
            </Allow>

            <Allow policyEvent={policyEvents.ADVANCE_SEARCH}>
                <SearchableSingleSelectField
                    {...searchForm.districtId}
                    {...inputSharedSettings}
                    defaultOption={"All"}
                    includeDefaultOption
                    label={'District'}
                    options={createListFromArrayOfObjects(districts, "id", "districtName")}
                />
            </Allow>

            <SelectField
                {...searchForm.isActive}
                {...inputSharedSettings}
                includeDefaultOption={false}
                options={createIsActiveList()}
            />
            <Allow policyEvent={policyEvents.ADVANCE_SEARCH}>
                <SelectField
                    {...searchForm.patronRole}
                    {...inputSharedSettings}
                    defaultOptionValue={""}
                    defaultOption={"Select a Role"}
                    includeDefaultOption
                    label={'Role'}
                    options={createListFromArrayOfObjects(jobTitles, "jobID", "jobTitle")}
                />
            </Allow>
            <SelectField
                {...searchForm.patronSubType}
                {...inputSharedSettings}
                defaultOptionValue={""}
                defaultOption={"Select a patron role"}
                includeDefaultOption
                label={'Patron Role'}
                options={isAdmin() ? createListFromArrayOfObjects(PatronRoleSubtypesMap, "key", "value") : createSubtypeListFromPatronRole(user.patronRole)}
            />


            <SelectField
                {...searchForm.approvalStatus}
                {...inputSharedSettings}
                includeDefaultOption
                options={APPROVAL_STATUS_LIST}
                defaultOptionValue={""}
                defaultOption={"Select an approval status"}
            />

            <GridCell>
                <GridContainer isReverseOrder isFlush hasPaddingX>
                    <Allow policyEvent={policyEvents.APPROVE_USERS}>
                        <GridCell>
                            <CheckBoxField
                                {...searchForm.showOnlyDelegates}
                                checked={!!searchForm.showOnlyDelegates.value}
                                label={
                                    "Show only delegates"
                                }
                                value={searchForm.showOnlyDelegates.value ? "" : "true"}
                            />
                        </GridCell>
                    </Allow>
                    <GridCell {...buttonSharedSettings}>
                        <Button
                            buttonType={inputStyles.button.types.SEARCH}
                            disabled={isLoading}
                            isPrimary
                            label="Search"
                            name="btnSearchUsers"
                            onClick={handleSearchClick}
                        />
                    </GridCell>
                    <GridCell {...buttonSharedSettings}>
                        <Button
                            buttonType={inputStyles.button.types.CLEAR}
                            disabled={isLoading}
                            label="Clear"
                            name="btnClearUserSearch"
                            onClick={handleClearClick}
                        />
                    </GridCell>
                </GridContainer>
            </GridCell>
        </InputForm>
    </>;
};